var React = require('react');

function Desensitization (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1818 1L21.7081 6.5V17.5M12.1818 1L2.65555 6.5V17.5M12.1818 1L12.181 5.39673M21.7081 17.5L12.1818 23L2.65555 17.5M21.7081 17.5L17.8996 15.3016M2.65555 17.5L6.46245 15.3016M12.181 5.39673L17.8996 8.69836M12.181 5.39673L6.46245 8.69836M17.8996 8.69836V15.3016M17.8996 8.69836L13.3342 11.3342M17.8996 15.3016L12.181 18.6032M12.181 18.6032L6.46245 15.3016M12.181 18.6032V13.3403M6.46245 15.3016V8.69836M6.46245 8.69836L11.0279 11.3342M13.5151 12C13.5151 12.7364 12.9181 13.3333 12.1818 13.3333C11.4454 13.3333 10.8484 12.7364 10.8484 12C10.8484 11.2636 11.4454 10.6667 12.1818 10.6667C12.9181 10.6667 13.5151 11.2636 13.5151 12Z","stroke":"currentColor","strokeWidth":"1.2","strokeLinejoin":"round"}));
}

Desensitization.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Desensitization;

Desensitization.default = Desensitization;
